import Reports from "./Reports";
import Location from "./Location/Routes";
import PropertyItem from "./Items/Routes";
import PropertyStore from "./Store/Routes";
import PropertyCategory from "./Categories/Routes";
import Settings from "./Settings/Routes";
import Inventory from "./Inventory/Routes";
import Transfer from "./Transfer/Routes";

export default [...PropertyItem, ...PropertyCategory, ...PropertyStore, ...Location, ...Reports, ...Settings, ...Inventory, ...Transfer];
